import { render, staticRenderFns } from "./unitInfo.vue?vue&type=template&id=5a61c5ac&scoped=true&"
import script from "./unitInfo.vue?vue&type=script&lang=js&"
export * from "./unitInfo.vue?vue&type=script&lang=js&"
import style0 from "./unitInfo.vue?vue&type=style&index=0&id=5a61c5ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a61c5ac",
  null
  
)

export default component.exports